module.exports = __webpack_public_path__ + "img/partner3.8fd48693.png";